// A top level block of a game report: a day (Games) or a referee (Referees)

export default function GameReportGroup({
  title,
  action,
  total,
  totalPay,
  payAction,
  className,
  children,
}) {
  return (
    <div className={'report-group' + (className ? ` ${className}` : '')}>
      {(title || action) && (
        <div className='header-row'>
          {title && <h4 className='header'>{title}</h4>}
          {action}
        </div>
      )}
      {children}
      <h4 className='total'>{total}</h4>
      {totalPay && (
        <div className='total-row'>
          <h4 className='total'>{totalPay}</h4>
          {payAction}
        </div>
      )}
    </div>
  );
}
